// import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useGetCalendarDay = (date) => {
    let day;
    const calendar =
        useSelector((state) => state.miniBookingWidget?.data?.futureDates) ||
        [];

    // useMemo(() => {
    for (let i = 0; i < calendar.length; i++) {
        const month = calendar[i];
        const days = month?.fd_JsonResult?.data?.days || [];
        day = days.find(function (day) {
            return day.date === date;
        });
        if (day) {
            break;
        }
    }
    return day;
    // }, [calendar]);
};

export default useGetCalendarDay;
